var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOficinasClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 83,
    viewBox: "0 0 78 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.1843 82.9996H64.6644C61.2807 81.3148 59.1473 77.906 56.1691 75.7243C45.8471 80.7327 33.3785 80.7898 22.8707 76.2405C20.2001 78.377 18.1529 81.4837 15.0237 82.9989H13.5037C11.2215 82.3176 9.93665 80.1336 11.045 77.9593C11.6246 76.8211 16.2761 72.9123 16.1983 72.5517C0.934958 62.0267 -4.47577 41.7262 4.00951 25.4596C-6.05505 7.77782 16.7979 -8.69391 31.81 5.2747C36.5841 4.3675 41.5354 4.41712 46.3118 5.26285C61.2198 -8.81388 84.2039 7.89187 73.989 25.4589C82.2808 41.3034 77.3387 61.3328 62.6419 71.8867C65.3966 74.9445 73.384 79.7374 66.1851 82.9996H66.1843ZM69.2219 18.268C70.6986 10.5927 62.1548 4.2579 54.8727 7.80448C57.7245 9.10937 60.4653 10.6579 62.9594 12.5256C65.2725 14.2578 67.2017 16.2425 69.2226 18.268H69.2219ZM8.77743 18.268C10.7814 16.2603 12.7522 14.2437 15.0406 12.5256C17.5332 10.6542 20.2741 9.11899 23.1243 7.80374C15.7512 4.39268 7.47176 10.6149 8.77743 18.268ZM38.4586 11.5021C13.2247 11.9124 -1.64169 39.486 12.8594 59.5266C26.2952 78.0956 55.5856 76.6707 66.8888 56.8264C78.6051 36.2564 62.7629 11.1067 38.4586 11.5021Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1685 42.2791H56.1375C56.2023 42.2791 57.1711 42.676 57.3253 42.7597C60.2796 44.3645 59.4009 48.6909 56.062 49.1827C49.5175 48.8568 41.9733 49.8669 35.539 49.2538C33.9366 49.1012 32.7342 48.2681 32.1554 46.8262L32.1138 22.1171C32.9524 19.2726 37.2763 18.7038 38.7292 21.3661C38.8047 21.5039 39.1678 22.3489 39.1678 22.4052V42.2791H39.1685Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 83,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOficinasClock);
export default __webpack_public_path__ + "static/media/oficinas-clock.a160e0b258b139ffdb7aaeeb531d1146.svg";
export { ForwardRef as ReactComponent };